import { RestrictionInterface } from '../../..';

export class CourseClothingRestrictionDto implements RestrictionInterface {
  isRestricted?: boolean;
  restriction?: string;
}
